import { memo } from "react"
import {
	IconCode2Outline18 as ApiIcon,
	IconAtom2Outline18 as AtomIcon,
} from "nucleo-ui-outline-18"

import { Avatar } from "@productlane/ui"

export type VersionAuthorSource = "USER" | "AI" | "API"

export interface VersionAuthorUser {
	name?: string | null
	email: string
	imageUrl?: string | null
}

interface VersionAuthorLineProps {
	source: VersionAuthorSource
	user?: VersionAuthorUser | null
}

// Rows saved before the author columns landed carry no user, so they render
// nothing rather than claiming an author we never recorded.
export const VersionAuthorLine = memo(
	({ source, user }: VersionAuthorLineProps) => {
		const name = user?.name ?? user?.email

		if (source === "AI") {
			return (
				<span className="flex items-center gap-1.5 text-xs text-secondary">
					<AtomIcon className="h-3.5 w-3.5 text-green-500" />
					AI
				</span>
			)
		}

		if (!name) return null

		return (
			<span className="flex items-center gap-1.5 text-xs text-secondary">
				{source === "API" ? (
					<ApiIcon className="h-3.5 w-3.5" />
				) : (
					<Avatar image={user?.imageUrl} name={name} size="xs" />
				)}
				{name}
				{source === "API" && <span className="text-tertiary">via API</span>}
			</span>
		)
	},
)

VersionAuthorLine.displayName = "VersionAuthorLine"
